<template>
  <div class="contenter buyerfinder-contenter" id="top">
    <div class="header1">
      <div class="logocontain">
        <span class="logo" />
      </div>
      <div>{{product&&product.prname||''}}</div>
      <div>
        <span>展会时间：{{product&&product.timeStr||''}}</span>
        <span>展会行业：{{product&&product.industry||''}}</span>
      </div>
    </div>
    <div class="content">
      <div class="datalist" v-if="!initial">
        <div class="tip" v-if="accountInfo&&accountInfo['emailfinder']&&countdowntip">
          <p>
            可搜索次数剩余
            <span
              :class="{red:true}"
              v-html="accountInfo.emailfinder.end_time!='-1'?'不限':(accountInfo.emailfinder.purchaser_search_times||0)"
            ></span>次
            <a-divider type="vertical" />可查看数据剩余
            <span
              :class="{red:true}"
              v-html="accountInfo.emailfinder.purchaser_detail_times||0"
            ></span>条
          </p>
          <a-icon type="close" @click="countdowntip=false" />
        </div>
        <div class="table-header">
          <p>
            共检索到
            <span class="totalcount" v-html="this.totalCount"></span>条相关数据信息
          </p>

          <p class="sort" v-show="countryList.length>0">
            筛选:
            <a-select size="small" v-model="orderType" show-search :filter-option="filterOption" :disabled="accountInfo.comboType==='1'">
              <a-select-option :value="0" key="0">全部国家</a-select-option>
              <template v-for="(v,i) in countryList">
                <a-select-option :value="v.country_id" :key="v.country_id">{{v.country}}</a-select-option>
              </template>
            </a-select>
          </p>
        </div>
        <div v-if="loading" style="text-align:center;margin:150px;">
          <a-spin tip="加载中...">
            <a-icon
              slot="indicator"
              type="loading"
              style="font-size: 48px;width:48px;height:48px;"
              spin
            />
          </a-spin>
        </div>
        <div v-else-if="dataSource.length">
          <ul class="list">
            <li v-for="(v,i) in dataSource" :key="i">
              <div>
                <a
                  target="_blank"
                  :class="{'title':true}"
                  @click="goToDetail(v)"
                  v-html="v.company"
                />
                <p>
                  <span class="b" v-html="v.country"></span>
                  <a-divider type="vertical" />
                  <span v-html="`${v.expocount+'参展记录'}`"></span>
                </p>
              </div>
            </li>
          </ul>
          <a-pagination
            v-if="accountInfo.comboType==='2'"
            v-model="pageNo"
            :total="totalCount"
            @change="changepage"
            :defaultPageSize="pageSize"
          />
        </div>
        <div v-else class="empty-list" v-show="emptyData">
          <p>
            未检索到
            <span v-html="oldSearchCondition"></span>相关数据信息!
          </p>
          <span>温馨提示：</span>
          <span>请检查您的输入是否正确或者更换新的词进行搜索吧。</span>
        </div>
      </div>
      <div class="initial" v-else></div>
    </div>
  </div>
</template>
<script>
const assert = require("assert");
import PinyinMatch from "pinyin-match";
import RechargeTip from "../RechargeTip";
import UpgradeTip from "../UpgradeTip";
// import CompanyInfo from "../CompanyInfo";
export default {
  data() {
    return {
      exhibition: false,
      initial: true,
      loading: false,
      advanced: true,
      countdowntip: true,
      orderType: 0,
      searchCondition: "",
      oldSearchCondition: "",
      emptyData: false,
      pageNo: 1,
      totalCount: 0,
      pageSize: 10,
      dataSource: [],
      countryList: [],
      searchType: 0,
      selecter: {
        industry: "0",
        industryName: "",
        industrySearch: "",
        industryCode: "",
        country: "",
        countryName: "",
        alphabet: "全部",
        alphabetSearch: "",
        years: ""
      },
      toggle: "",
      product:{}
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.searchType = parseInt((to.query && to.query.st) || 0);
      vm.searchCondition = (to.query && to.query.search) || "";
      if (vm.searchCondition != "") {
        vm.search();
      }
    });
  },
  watch: {
    orderType() {
      this.pageNo = 1;
      this.search();
    },
    $route(n, o) {
      if (n.query.st != o.query.st) {
        this.init();
      }
    }
  },
  computed: {
    accountInfo() {
      return this.$store.state.accountInfo;
    }
  },
  methods: {
    init() {
      this.exhibition = false;
      this.initial = true;
      this.loading = false;
      this.advanced = true;
      this.countdowntip = true;
      this.orderType = 0;
      this.searchCondition = "";
      this.oldSearchCondition = "";
      this.emptyData = false;
      this.pageNo = 1;
      this.totalCount = 0;
      this.pageSize = 10;
      this.dataSource = [];
      this.searchType = this.$route.query.st || 0;
      this.selecter = {
        industry: "0",
        industryName: "",
        industrySearch: "",
        industryCode: "",
        country: "",
        countryName: "",
        alphabet: "全部",
        alphabetSearch: "",
        years: ""
      };
      this.toggle = "";
    },
    async getProduct() {
      if (!this.accountInfo) {
        return this.$loginFrm();
      }
      let exhibition;
      let prId = this.$route.query.prId;
      if (!exhibition && prId) {
      let res=await this.$http.post("/zzGetExpo", { id: prId });
      console.log(res);
      if (res.error == 0) {
            exhibition = res.data.list && res.data.list[0];
      }
      }
      document.title =
        exhibition.soid == this.$route.params.soid ? exhibition.prname : "";
      this.product=(exhibition.soid == this.$route.params.soid ? exhibition : {});
    },
    search() {
      if (!this.accountInfo) {
        return this.$loginFrm();
      }
      // if (!!this.accountInfo && !this.accountInfo.company) {
      //   return this.$dialog(CompanyInfo);
      // }
      /* 
        无剩余查询次数判断:supgrade
      */
      if (
        this.accountInfo.emailfinder.end_time == "-1" &&
        this.accountInfo.emailfinder.purchaser_search_times == 0
      ) {
        return this.$dialog(UpgradeTip, {
          tipType: "supgrade",
          accountInfo: this.accountInfo
        });
      }
      this.initial = false;
      this.loading = true;
      this.$http
        .post("/zzPurchaserList", {
          pageNo: this.pageNo,
          pageSize: this.pageSize,
          orderType: this.orderType,
          type: 4,
          soId: this.$route.params.soid || 0
        })
        .then(res => {
          this.loading = false;
          if (!res.error) {
            console.log(res);
            this.totalCount = parseInt(res.totalCount || 0);
            this.pageNo = parseInt(res.pageNo || 1);
            this.pageSize = parseInt(res.pageSize || 10);
            this.dataSource = res.data.list || [];
            if (this.dataSource.length>5&&this.accountInfo.comboType==="1") {
              this.dataSource=this.dataSource.slice(0,5)
            }
            this.emptyData = this.dataSource.length == 0;
            this.oldSearchCondition = this.searchCondition;
            this.countryList = res.countryArr || [];
          } else {
            switch (res.error) {
              case 10504:
                /* 
                  无剩余查询次数
                */
                return this.$dialog(UpgradeTip, {
                  tipType: "supgrade",
                  accountInfo: this.accountInfo
                });
              case 1010: //搜索过多提醒
                res.errorMsg &&
                  this.$notification.info({
                    message: "提醒",
                    description: res.errorMsg
                  });
                break;
              default:
                res.errorMsg && this.$message.error(res.errorMsg);
                break;
            }
          }
          document.getElementById("top").scrollIntoView();
        })
        .catch(e => {
          this.loading = false;
        });
    },
    changepage(v) {
      //this.$router.push({ path: `/buyerfinder/${v}` });
      this.pageNo = v;
      this.search();
    },
    goToDetail(v) {
      if (!v.isLook) {
        if (!this.accountInfo) {
          return this.$loginFrm();
        }
        if (this.accountInfo.emailfinder.purchaser_detail_times == 0) {
          return this.$dialog(UpgradeTip, {
            tipType: "upgrade",
            accountInfo: this.accountInfo
          });
        }
      }

      //提前访问详情，保证次数正常
      this.loading = true;
      this.$http
        .post("/zzGetPurchaserDetail", {
          pid: v.id || 0,
          type: 2
        })
        .then(res => {
          this.loading = false;
          console.log(res);
          if (!res.error) {
            let purchaseDetail = {
              detail: res.data.detail,
              isCollect: res.data.detail.is_collect == "0" ? false : true
            };
            //this.$setStore('purchaseDetail',purchaseDetail);
            this.$refreshAccountInfo();
            this.$getWetchatExplore()
              ? this.$router.push({
                  path: `/buyerfinder/detail/${v.id}?type=4`
                })
              : window.open(`/buyerfinder/detail/${v.id}?type=4`);
          } else {
            //this.$router.push({ path: "/" });
            this.$notification.info({
              message: "提醒",
              description: res.errorMsg
            });
          }
        })
        .catch(e => {
          this.loading = false;
          this.$router.push({ path: "/" });
          this.$notification.error({
            message: "错误",
            description: e
          });
        });
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    }
  },
  mounted() {
    this.pageNo = parseInt(this.$route.params.pageNo || 1);
  },
 async created() {
   this.loading = true;
   await this.getProduct();
    this.search();
  }
};
</script>
<style lang="scss" scoped>
@import "~@/components/layout/style/mixin.scss";
.buyerfinder-contenter {
  & /deep/ .ant-btn,
  & /deep/ .ant-input {
    border-radius: 0;
  }

  .btn-small-search {
    background: #f6f6f6;
    color: #999;
    font-size: 12px;
  }
  .anticon-search:before {
    color: #ececec;
    transform: scale(0.9);
    font-weight: bold;
  }
  background: #f9f9f9;
  .content {
    margin: auto;
    width: 1200px;
    min-height: 600px;
    .initial {
      &:before {
        display: block;
        height: 140px;
        width: 240px;
        background: red;
        margin: 100px auto 0;
        @include intop-icon;
        background-position: -370px 0px;
        content: " ";
      }
      &:after {
        display: block;
        content: "小二等候多时了，输入关键词开始检索吧！";
        text-align: center;
        font-size: 16px;
        color: #1dbc87;
        height: 140px;
        width: 220px;
        margin: 0 auto 100px;
      }
    }
    .datalist {
      margin-top: 10px;
      background: #fff;
      .tip {
        padding: 0 0 10px;
        background: #f9f9f9;
        font-size: 13px;
        color: #8a6d5b;
        position: relative;
        p {
          margin: 0;
          height: 40px;
          line-height: 40px;
          text-align: center;
          background-color: #fcf8e3;
          .red {
            color: #f2352f;
          }
        }
        .anticon-close {
          position: absolute;
          top: 13px;
          right: 20px;
        }
      }
      .table-header {
        display: flex;
        flex-flow: row;
        border-bottom: 1px solid #e5e5e5;
        p {
          padding: 0 10px;
          display: inline-block;
          vertical-align: middle;
          margin: 0;
          line-height: 43px;
          height: 43px;
          flex: 1;
          font-size: 12px;
          color: #666;
          .totalcount {
            color: #f2352f;
            font-weight: bold;
          }
        }
        .sort {
          color: #999;
          font-size: 13px;
          text-align: right;
          .ant-select {
            margin: 0 10px;
            width: 100px;
          }
        }
      }
      .list {
        list-style: none;
        padding: 0px;
        li {
          height: 120px;
          border-bottom: 3px solid #f9f9f9;
          padding: 0 20px;
          position: relative;
          .title {
            line-height: 24px;
            display: inline-block;
            height: 24px;
            margin: 35px 0 0 0;
          }
          .has-linkman::after {
            content: " ";
            width: 40px;
            height: 24px;
            display: inline-block;
            line-height: 24px;
            vertical-align: top;
            @include intop-icon;
            background-position: -390px -655px !important;
          }
          p {
            margin: 5px 0 0 0;
            font-size: 13px;
            .b {
              font-weight: bold;
            }
          }
          .mark {
            position: absolute;
            right: 40px;
            top: 50px;
            display: inline-block;
            width: 90px;
            border: 1px solid #f0f0f0;
            height: 30px;
            line-height: 30px;
            padding: 0 20px;
            border-radius: 20px;
            background: #f9f9f9;
            color: #999;
            .anticon {
              color: #ff6b6b;
              margin-right: 5px;
            }
          }
        }
      }
    }
    .ant-pagination {
      height: 60px;
      padding: 10px 20px;
    }
    .empty-list {
      padding: 20px;
      p {
        font-size: 16px;
        color: #333;
        font-weight: bold;
        margin-bottom: 5px;
        span {
          color: #f00;
        }
      }
      & > span {
        font-size: 12px;
        display: block;
        margin-bottom: 5px;
        color: #999;
      }
    }
  }
  .header1 {
    padding-bottom: 20px;
    background: url("~@/assets/img/buyer_banner.jpg");
    text-align: left;
    border-bottom: 6px solid #ff6b6b;
    .logocontain {
      text-align: left;
      margin: 0 auto;
      width: 1200px;
      height: 90px;
      .logo {
        display: inline-block;
        width: 200px;
        height: 70px;
        @include intop-icon;
        background-position: -40px -400px !important;
        margin: 15px 0 0 -10px;
      }
    }
    & > div {
      text-align: center;
      color: #fff;
      &:nth-child(2) {
        font-size: 50px;
        margin-bottom: 20px;
      }
      &:nth-child(3) {
        color: #999;
        margin-bottom: 10px;
        & > span:first-child {
          margin-right: 40px;
        }
      }
    }
  }
}
</style>